export default __webpack_public_path__ + "static/tile-4-bg-22906cf7f01260f0ddc630f79755b07a.png";